import React from 'react';
import { Link } from 'react-router-dom';

const values = [
  {
    icon: '💡',
    title: 'الابتكار المستمر',
    desc: 'نسعى دائماً لتطوير حلول تقنية مبتكرة تلبي احتياجات السوق المتغيرة.',
  },
  {
    icon: '🤝',
    title: 'الشراكة الحقيقية',
    desc: 'نبني علاقات طويلة الأمد مع عملائنا قائمة على الثقة والاحترام المتبادل.',
  },
  {
    icon: '⭐',
    title: 'الجودة أولاً',
    desc: 'لا نتنازل عن الجودة في كل ما نقدمه، من المحتوى إلى تجربة المستخدم.',
  },
  {
    icon: '🔒',
    title: 'الأمان والخصوصية',
    desc: 'نحمي بيانات مستخدمينا وشركائنا بأعلى معايير الأمان والخصوصية.',
  },
];

const team = [
  {
    emoji: '👨‍💼',
    name: 'أحمد المحمدي',
    role: 'المؤسس والرئيس التنفيذي',
    bio: 'خبرة تتجاوز 15 عاماً في قطاع التقنية والترفيه الرقمي، قاد مسيرة استراحة شاشتنا  منذ انطلاقتها.',
  },
  {
    emoji: '👩‍💻',
    name: 'سارة العمري',
    role: 'مديرة تطوير المنتج',
    bio: 'متخصصة في هندسة البرمجيات وتجربة المستخدم، مسؤولة عن رسم خريطة تطور الاستراحة.',
  },
  {
    emoji: '👨‍🎨',
    name: 'خالد الزهراني',
    role: 'مدير التصميم الإبداعي',
    bio: 'مصمم إبداعي شغوف بصناعة تجارب بصرية استثنائية، يقود فريق تصميم استراحة شاشتنا .',
  },
];

const timeline = [
  {
    year: '2025',
    title: 'الفكرة والتأسيس',
    desc: 'وُلدت فكرة استراحة شاشتنا من حاجة حقيقية لتوفير ترفيه عالي الجودة في الأماكن المغلقة دون الاعتماد على الإنترنت.',
  },
  {
    year: '2026',
    title: 'النموذج الأولي',
    desc: 'أطلقنا النسخة التجريبية الأولى في 5 فنادق بصنعاء، وحققنا نتائج مبهرة فاقت التوقعات.',
  },
  {
    year: '2026',
    title: 'التوسع والنمو',
    desc: 'توسعنا لتغطية 50 منشأة في 3 مواقع بصنعاء، وأطلقنا تطبيق الجوال الرسمي لنظامي iOS وAndroid.',
  },
  {
    year: '2026',
    title: 'الانطلاق الإقليمي',
    desc: 'دخلنا سوق اليمن بصنعاء، وتجاوز عدد مستخدمينا 50 ألف مستخدم نشط.',
  },
  {
    year: '2026',
    title: 'مرحلة التميز',
    desc: 'نستهدف تغطية 500 منشأة في صنعاء وعموم اليمن، مع إطلاق ميزات ذكاء اصطناعي لتخصيص تجربة المشاهدة.',
  },
];

function AboutUs() {
  return (
    <>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="bg-blobs">
          <div className="blob blob-1" />
          <div className="blob blob-2" />
        </div>
        <div className="grid-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <span className="page-hero-badge">🏢 من نحن</span>
          <h1 className="page-hero-title">
            نحن نصنع{' '}
            <span className="gradient-text">مستقبل الترفيه</span>
            <br />
            داخل شبكتك المحلية
          </h1>
          <p className="page-hero-subtitle">
            فريق من الشغوفين بالتقنية والترفيه، يعملون معاً لتقديم تجربة
            مشاهدة لا مثيل لها في الأماكن المغلقة.
          </p>
        </div>
      </section>

      <div className="divider" />

      {/* Company Story */}
      <section className="section">
        <div className="bg-blobs" style={{ opacity: 0.4 }}>
          <div className="blob blob-1" style={{ width: '350px', height: '350px' }} />
        </div>
        <div className="grid-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="story-section">
            <div className="story-text">
              <div className="glow-line" style={{ margin: '0 0 var(--spacing-xl) 0' }} />
              <h3>
                قصتنا مع{' '}
                <span className="gradient-text">استراحة شاشتنا </span>
              </h3>
              <p>
                بدأت قصة استراحة شاشتنا في عام 2025 عندما لاحظ مؤسسونا فجوة كبيرة في
                سوق الترفيه داخل المنشآت المغلقة. كانت الفنادق والمستشفيات والمقاهي
                تعتمد على اشتراكات إنترنت مكلفة لتوفير محتوى ترفيهي متواضع الجودة.
              </p>
              <p>
                رأى فريقنا فرصة حقيقية في توظيف شبكات واي فاي المحلية الموجودة أصلاً
                في هذه المنشآت لتقديم تجربة ترفيهية احترافية وغنية بالمحتوى، دون
                أي تكلفة إضافية على الإنترنت الخارجي.
              </p>
              <p>
                اليوم، بعد سنوات من العمل والتطوير، أصبحنا شركاء موثوقين لمئات
                المنشآت في اليمن، ونفخر بتقديم تجربة مشاهدة استثنائية
                لأكثر من 50 ألف مستخدم شهرياً.
              </p>
              <div style={{ marginTop: 'var(--spacing-xl)' }}>
                <Link to="/support" className="btn-primary">
                  <span>🤝</span>
                  <span>انضم إلينا</span>
                </Link>
              </div>
            </div>
            <div className="story-visual">
              <div className="story-visual-card">
                <div className="bg-blobs" style={{ opacity: 0.3 }}>
                  <div className="blob blob-3" style={{ width: '200px', height: '200px' }} />
                </div>
                <span className="story-visual-icon">🎬</span>
                <h4 style={{
                  fontSize: '1.2rem',
                  fontWeight: '800',
                  marginBottom: 'var(--spacing-sm)',
                  position: 'relative',
                  zIndex: 1
                }}>
                  أرقام تتحدث عن نفسها
                </h4>
                <p style={{
                  color: 'var(--text-secondary)',
                  fontSize: '0.9rem',
                  marginBottom: 'var(--spacing-xl)',
                  position: 'relative',
                  zIndex: 1
                }}>
                  منذ تأسيسنا حتى اليوم
                </p>
                <div className="story-visual-stats">
                  {[
                    { number: '+500', label: 'محتوى' },
                    { number: '+50K', label: 'مستخدم' },
                    { number: '+200', label: 'منشأة' },
                    { number: '1', label: 'دولة' },
                  ].map((s) => (
                    <div className="story-stat" key={s.label}>
                      <div className="story-stat-number">{s.number}</div>
                      <div className="story-stat-label">{s.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* Mission & Vision */}
      <section className="section section-alt">
        <div className="dot-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="glow-line" />
          <h2 className="section-title">
            رسالتنا{' '}
            <span className="gradient-text">ورؤيتنا</span>
          </h2>
          <p className="section-subtitle">
            نؤمن بأن الترفيه الجيد حق للجميع، ونسعى لتوفيره في كل مكان وزمان.
          </p>
          <div className="mission-vision-grid">
            <div className="mv-card mv-card-mission">
              <div className="mv-card-header">
                <span className="mv-icon">🎯</span>
                <h3 className="mv-title gradient-text">رسالتنا</h3>
              </div>
              <p className="mv-text">
                تمكين المنشآت من تقديم تجربة ترفيهية احترافية ومتكاملة لضيوفها
                ومستخدميها من خلال توظيف البنية التحتية للشبكات المحلية الموجودة،
                وتحقيق قيمة مضافة حقيقية دون تكاليف إضافية أو تعقيدات تقنية.
                نؤمن بأن جودة التجربة الترفيهية تنعكس مباشرة على رضا الضيوف
                وسمعة المنشأة.
              </p>
            </div>
            <div className="mv-card mv-card-vision">
              <div className="mv-card-header">
                <span className="mv-icon">🔭</span>
                <h3 className="mv-title gradient-text-gold">رؤيتنا</h3>
              </div>
              <p className="mv-text">
                أن نكون الاستراحة الأولى والأكثر ثقة للترفيه عبر الشبكات المحلية
                في اليمن وصنعاء، ونطمح لأن يكون اسم استراحة شاشتنا مرادفاً
                لجودة الترفيه الداخلي في كل فندق ومستشفى ومقهى ومركز تجاري
                في صنعاء واليمن بحلول عام 2030.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* Core Values */}
      <section className="section">
        <div className="bg-blobs" style={{ opacity: 0.3 }}>
          <div className="blob blob-2" style={{ width: '300px', height: '300px' }} />
        </div>
        <div className="grid-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="glow-line" />
          <h2 className="section-title">
            قيمنا{' '}
            <span className="gradient-text">الجوهرية</span>
          </h2>
          <p className="section-subtitle">
            هذه القيم هي أساس كل قرار نتخذه وكل منتج نبنيه وكل علاقة نبنيها.
          </p>
          <div className="values-grid">
            {values.map((value) => (
              <div className="value-card" key={value.title}>
                <span className="value-icon">{value.icon}</span>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-desc">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* Team Section */}
      <section className="section section-alt">
        <div className="dot-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="glow-line" />
          <h2 className="section-title">
            فريقنا{' '}
            <span className="gradient-text">المتميز</span>
          </h2>
          <p className="section-subtitle">
            خلف كل منتج رائع فريق استثنائي من الموهوبين الشغوفين بالتقنية والإبداع.
          </p>
          <div className="team-grid">
            {team.map((member) => (
              <div className="team-card" key={member.name}>
                <div className="team-avatar">
                  <div className="team-avatar-inner">{member.emoji}</div>
                </div>
                <h3 className="team-name">{member.name}</h3>
                <p className="team-role">{member.role}</p>
                <p className="team-bio">{member.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* Timeline */}
      <section className="section">
        <div className="bg-blobs" style={{ opacity: 0.3 }}>
          <div className="blob blob-1" style={{ width: '300px', height: '300px' }} />
        </div>
        <div className="grid-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="glow-line" />
          <h2 className="section-title">
            مسيرة{' '}
            <span className="gradient-text">نجاحنا</span>
          </h2>
          <p className="section-subtitle">
            رحلة من الحلم إلى الواقع، محطة بمحطة.
          </p>
          <div className="timeline">
            {timeline.map((item, index) => (
              <div className="timeline-item" key={index}>
                <div className="timeline-dot" />
                <div className="timeline-content">
                  <div className="timeline-year">{item.year}</div>
                  <h4 className="timeline-title">{item.title}</h4>
                  <p className="timeline-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* CTA Banner */}
      <section className="cta-banner section-alt">
        <div className="bg-blobs" style={{ opacity: 0.3 }}>
          <div className="blob blob-1" />
          <div className="blob blob-2" />
        </div>
        <div className="dot-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="cta-banner-inner">
            <div style={{ fontSize: '3rem', marginBottom: 'var(--spacing-lg)' }}>🌟</div>
            <h2 className="cta-banner-title">
              كن جزءاً من{' '}
              <span className="gradient-text">قصة نجاحنا</span>
            </h2>
            <p className="cta-banner-subtitle">
              سواء كنت منشأة تبحث عن حل ترفيهي أو مستثمراً يرى الفرصة،
              نحن نرحب بك في عائلة استراحة شاشتنا .
            </p>
            <div className="cta-buttons">
              <Link to="/support" className="btn-primary">
                <span>📞</span>
                <span>تواصل معنا</span>
              </Link>
              <Link to="/" className="btn-outline">
                <span>🏠</span>
                <span>الصفحة الرئيسية</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutUs;